import { Link } from 'react-router-dom'

/** 404 catch-all — no more blank screens on unknown routes. */
export default function NotFound () {
  return (
    <div className='min-h-[70vh] flex items-center justify-center px-5 text-center'>
      <div>
        <div className='text-6xl mb-4'>🍽️</div>
        <h1 className='text-2xl font-bold text-gray-900 mb-2'>Page not found</h1>
        <p className='text-gray-500 mb-6'>
          The page you’re looking for doesn’t exist or has moved.
        </p>
        <Link
          to='/home'
          className='inline-block bg-[#065f2a] text-white font-semibold px-6 py-3 rounded-xl'
        >
          Back to Home
        </Link>
      </div>
    </div>
  )
}
